import type { HTMLAttributes } from 'react'
import ShipmentCalculatedValue from '../../../../components/shipment-calculated-value/shipment-calculated-value'
import {
    getShipmentFloods,
    isShipmentFloodsActual,
} from '../../../../helpers/entities/shipment/get-shipment-floods'
import { validateFloods } from '../../../../helpers/table-cell-validators'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import ShipmentFloodsCell from '../../components/cells/form-items/shipment-floods-cell'

export const stampFloodsColumn: ShipmentColumn = {
    dataIndex: ['stampFloods'],
    title: 'Р',
    width: 30,
    editable: true,
    FormItem: <ShipmentFloodsCell />,
    validator: validateFloods,
    render: (_v: number, r: DataSourceItem) => {
        const floods = getShipmentFloods(r)
        const isActual = isShipmentFloodsActual(r)

        return (
            <ShipmentCalculatedValue isActual={isActual}>{floods ?? ''}</ShipmentCalculatedValue>
        )
    },
    onCell: (record: DataSourceItem, index?: number) =>
        ({
            ...onCellStandard(record, index ?? 0),
            /** Без высечки — в форме поле virtualStamp.floods, иначе stampFloods (как в расчётах). */
            dataIndex: record.withoutCutting ? ['virtualStamp', 'floods'] : 'stampFloods',
            /** После фиксации расхода показываем actualFloods — план не редактируем. */
            editable: !isShipmentFloodsActual(record),
        }) as HTMLAttributes<HTMLTableCellElement>,
}
